<template>
  <v-card
    rounded
    outlined
    class="d-flex justify-space-between w-100 pe-4 card-empty"
  >
    <div class="ps-8 py-8">
      <p
        class="subtitle-2 font-weight-bold blue-grey--text text--darken-3 mb-0"
      >
        {{ $t('home.to_do.empty_state.embark_on_a_new_project') }}
      </p>
      <p
        class="blue-grey--text text--darken-1 text-caption mb-2"
        style="max-width: 300px;"
        v-html="$t('home.to_do.empty_state.discover_revs')"
      />
      <Button
        color="primary"
        :text="$t('common.button.start_now')"
        @click="handleCreateClick"
      />
    </div>
    <img
      :src="EmptyStateImage"
      alt="empty_state"
      :width="$vuetify.breakpoint.mobile ? 250 : 334"
    />
    <CreateContentModal
      v-if="showCreateModal"
      :show="showCreateModal"
      @close="showCreateModal = false"
    />
  </v-card>
</template>

<script>
import Button from '@/components/UI/Button.vue'
import EmptyStateImage from '@/assets/images/empty-states/empty-state-to-do.svg'
import CreateContentModal from '@/components/CreateContentModal/CreateContentModal.vue'
import trackingMixin from '@/mixins/tracking/trackerMixin.vue'

export default {
  name: 'ToDoEmptyState',
  mixins: [trackingMixin],
  components: {
    Button,
    CreateContentModal,
  },
  data() {
    return {
      EmptyStateImage,
      showCreateModal: false,
    }
  },
  methods: {
    handleCreateClick() {
      this.showCreateModal = true
      this.trackHomeNavigate({ section: 'toDoEmptyState', element: 'create' })
    },
  },
}
</script>
<style lang="scss" scoped>
.card-empty {
  border: 1px solid $color-blue !important;
  background: $color-blue-lighten2 !important;
}
</style>
